/**
 * Retorna la URL de redirección para Supabase Auth basada en el entorno.
 * @returns {string} La URL de redirección absoluta.
 */
export const getRedirectUrl = () => {
    // Determinamos si estamos en producción basado en el hostname o la variable de entorno
    const isProduction =
        window.location.hostname === 'tetrisbiblico.com' ||
        process.env.NODE_ENV === 'production';

    // URL de producción (Tetris Bíblico)
    if (isProduction) {
        return "https://tetrisbiblico.com/auth/callback";
    }

    // Desarrollo (localhost)
    // El puerto suele ser 3000 para React (CRA)
    return `http://localhost:3000/auth/callback`;
};
